import { AdminPageShell } from "../components/index.js";
import { QuizEditor } from "../features/quizzes/index.js";
import { useT } from "../i18n/index.js";

export function AdminQuizEditorPage() {
  const t = useT();
  return (
    <AdminPageShell
      crumbs={[
        { label: t("admin.quizzes"), to: "/admin/quizzes" },
        { label: t("admin.edit") },
      ]}
    >
      <QuizEditor />
    </AdminPageShell>
  );
}
